module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/call-03f39b13611a5f4e6f0ffe2b5fbf1b83.png";